module.exports = __webpack_public_path__ + "static/centro-obstetrico-b-8a616c5d5d2db2fb46deedf7aeec20bf.jpg";